import React from 'react';
import OneClubRegisterForm from './forms/one-club-register/OneClubRegisterForm';
import UserRegisterSuccessForm from './forms/user-register-success-form/UserRegisterSuccessForm';
import BallotRegisterForm from './forms/ballot/BallotRegisterForm';
import BallotSummaryForm from './forms/ballot/BallotSummaryForm';
import SSOItemListForm from './forms/item-list/SSOItemListForm';
import BallotSignInForm from './forms/ballot/BallotSignInForm';
import BallotSignInSuccessForm from './forms/ballot/BallotSignInSuccessForm';
import ForgotPasswordForm from './forms/forgot-password/ForgotPasswordForm';
import ResetPasswordForm from './forms/reset-password/ResetPasswordForm';
import UserAccountPage from './user-account/UserAccountPage';
import DefaultRegisterForm from './forms/default-register/DefaultRegisterForm';
import TicketingRegisterForm from './forms/ticketing-register/TicketingRegisterForm';
import SignInForm from './forms/sign-in/SignInForm';
import UpgradeToTicketingAccountForm from './forms/upgrade-to-ticketing/UpgradeToTicketingAccountForm';
import UpgradeToOneClubAccountForm from './forms/upgrade-to-one-club/UpgradeToOneClubAccountForm';
import VerifyEmailForm from './forms/verify-email/VerifyEmailForm';
import NewPasswordRequiredForm from './forms/new-password-required/NewPasswordRequiredForm';
import { ssoFormTypes } from './utils/form-types';
import SignInSuccessForm from './forms/sign-in/SignInSuccessForm';

/* eslint-disable */
export const ssoFormConstants = {
    [ssoFormTypes.OneClubRegister]: ({
        formData,
        ssoDomain,
        handleUserRegisterSuccess,
        handleSignIn,
        handleForgotPassword,
        loadSSORegisterFormData,
        ssoFormType }) => {
        return <OneClubRegisterForm
            registerFormData={formData}
            ssoDomain={ssoDomain}
            onUserRegisterSuccess={handleUserRegisterSuccess}
            onSignIn={handleSignIn}
            onForgotPassword={handleForgotPassword}
            loadSSORegisterFormData={loadSSORegisterFormData}
            ssoFormType={ssoFormType} ></OneClubRegisterForm >
    },
    [ssoFormTypes.DefaultRegister]: ({
        formData,
        ssoDomain,
        handleUserRegisterSuccess,
        handleSignIn,
        handleForgotPassword }) => {
        return <DefaultRegisterForm
            formData={formData}
            ssoDomain={ssoDomain}
            onUserRegisterSuccess={handleUserRegisterSuccess}
            onSignIn={handleSignIn}
            onForgotPassword={handleForgotPassword}></DefaultRegisterForm>
    },
    [ssoFormTypes.TicketingRegister]: ({
        formData,
        ssoDomain,
        handleUserRegisterSuccess,
        handleSignIn,
        handleForgotPassword }) => {
        return <TicketingRegisterForm
            registerFormData={formData}
            ssoDomain={ssoDomain}
            onUserRegisterSuccess={handleUserRegisterSuccess}
            onSignIn={handleSignIn}
            onForgotPassword={handleForgotPassword}></TicketingRegisterForm>
    },
    [ssoFormTypes.UpgradeToTicketingAccount]: ({ formData, ssoDomain, handleSignIn }) => {
        return <UpgradeToTicketingAccountForm
            formData={formData}
            ssoDomain={ssoDomain}
            onSignIn={handleSignIn}
        ></UpgradeToTicketingAccountForm>
    },
    [ssoFormTypes.UpgradeToOneClubAccountFromDefault]: ({ formData, handleSignIn }) => {
        return <UpgradeToOneClubAccountForm
            onSignIn={handleSignIn}
            formData={formData}
            ssoFormType={ssoFormTypes.UpgradeToOneClubAccountFromDefault}
        ></UpgradeToOneClubAccountForm>
    },
    [ssoFormTypes.UpgradeToOneClubAccountFromTicketing]: ({ formData, handleSignIn }) => {
        return <UpgradeToOneClubAccountForm
            formData={formData}
            onSignIn={handleSignIn}
            ssoFormType={ssoFormTypes.UpgradeToOneClubAccountFromTicketing}
        ></UpgradeToOneClubAccountForm>
    },
    [ssoFormTypes.SignIn]: ({
        formData,
        handleForgotPassword,
        handleRegister,
        handleNewPasswordRequired,
        handleSignInSucces
    }) => {
        return <SignInForm
            signInFormData={formData}
            onForgotPassword={handleForgotPassword}
            onRegister={handleRegister}
            onNewPasswordRequired={handleNewPasswordRequired}
            onSignInSuccess={handleSignInSucces}></SignInForm >
    },
    [ssoFormTypes.SignInSuccess]: ({
        formData,
        ssoDomain,
    }) => {
        return <SignInSuccessForm
            formData={formData}
            ssoDomain={ssoDomain}>
        </SignInSuccessForm >
    },
    [ssoFormTypes.NewPasswordRequired]: ({ cognitoUser, handleSignIn, handleSignInSucces }) => {
        return <NewPasswordRequiredForm
            cognitoUser={cognitoUser}
            onSignIn={handleSignIn}
            onResetSuccess={handleSignInSucces}
        ></NewPasswordRequiredForm >
    },
    [ssoFormTypes.ForgotPassword]: ({ formData, handleSignIn }) => {
        return <ForgotPasswordForm
            forgotPasswordFormData={formData}
            onSignIn={handleSignIn}></ForgotPasswordForm>
    },
    [ssoFormTypes.BallotForgotPassword]: ({ formData, handleBallotSignIn }) => {
        return <ForgotPasswordForm
            forgotPasswordFormData={formData}
            onSignIn={handleBallotSignIn}></ForgotPasswordForm>
    },
    [ssoFormTypes.ResetPassword]: ({ formData }) => {
        return <ResetPasswordForm
            resetPasswordFormData={formData}></ResetPasswordForm>
    },
    [ssoFormTypes.VerifyEmail]: ({ formData }) => {
        return <VerifyEmailForm
            verifyEmailFormData={formData}></VerifyEmailForm>
    },
    [ssoFormTypes.OneClubRegisterSuccess]: ({
        emailAddress,
        ssoDomain,
        requestEmailVerificationCallbackUrl,
        actionSuccessText,
        requestEmailVerificationActionSuccessText,
        displayBanner,
        isBallotRegister,
        handleSignIn,
        handleBallotSignIn,
        bannerBackgroundImageSrc,
        bannerSuccessRegistration}) => {
        return <UserRegisterSuccessForm
        emailAddress={emailAddress}
        ssoDomain={ssoDomain}
        isBallotRegister={isBallotRegister}
        requestEmailVerificationCallbackUrl={requestEmailVerificationCallbackUrl}
        actionSuccessText={actionSuccessText}
        requestEmailVerificationActionSuccessText={requestEmailVerificationActionSuccessText}
        displayBanner={displayBanner}
        onSignIn={handleSignIn}
        onBallotSignIn={handleBallotSignIn}
        bannerBackgroundImageSrc={bannerBackgroundImageSrc}
        bannerSuccessRegistration={bannerSuccessRegistration}></UserRegisterSuccessForm >
    },
    [ssoFormTypes.UserAccount]: ({ formData }) => {
        return <UserAccountPage
            accountFormData={formData}></UserAccountPage>
    },
    [ssoFormTypes.BallotLiteRegister]: ({
        formData,
        ssoDomain,
        handleUserRegisterSuccess,
        handleBallotSignIn,
        ssoFormType }) => {
        return <BallotRegisterForm
            registerFormData={formData}
            ssoDomain={ssoDomain}
            onUserRegisterSuccess={handleUserRegisterSuccess}
            onSignIn={handleBallotSignIn}
            ssoFormType={ssoFormType}
        ></BallotRegisterForm >
    },
    [ssoFormTypes.BallotFullRegister]: ({
        formData,
        ssoDomain,
        handleUserRegisterSuccess,
        handleBallotSignIn,
        loadSSORegisterFormData,
        ssoFormType }) => {
        return <OneClubRegisterForm
            registerFormData={formData}
            ssoDomain={ssoDomain}
            onUserRegisterSuccess={handleUserRegisterSuccess}
            onSignIn={handleBallotSignIn}
            loadSSORegisterFormData={loadSSORegisterFormData}
            ssoFormType={ssoFormType}
        ></OneClubRegisterForm>
    },
    [ssoFormTypes.UpgradeToTicketingAccount]: ({ formData, handleSignIn }) => {
        return <UpgradeToTicketingAccountForm
            formData={formData}
            onSignIn={handleSignIn}
        ></UpgradeToTicketingAccountForm>
    },
    [ssoFormTypes.BallotSummaryForm]: ({
        formData,
        ssoDomain,
        handleSignIn,
        handleBallotSummarySuccess,
        handleBallotPortalRedirect }) => {
        return <BallotSummaryForm
            formData={formData}
            ssoDomain={ssoDomain}
            onSignIn={handleSignIn}
            handleBallotSummarySuccess={handleBallotSummarySuccess}
            handleBallotPortalRedirect={handleBallotPortalRedirect}></BallotSummaryForm>
    },
    [ssoFormTypes.SSOItemListForm]: ({
        formData,
        ssoDomain,
        handleBallotPortalRedirect,
        formId,
        isFromBallot }) => {
        return <SSOItemListForm
            formData={formData}
            ssoDomain={ssoDomain}
            handleBallotPortalRedirect={handleBallotPortalRedirect}
            formId={formId}
            isFromBallot={isFromBallot}></SSOItemListForm>
    },
    [ssoFormTypes.BallotSignInForm]: ({
        formData,
        ssoDomain,
        handleCognitoHostedUISignIn,
        handleBallotForgotPassword,
        handleBallotRegister }) => {
        return <BallotSignInForm
            isBallotFlow={true}
            formData={formData}
            ssoDomain={ssoDomain}
            onSignIn={handleCognitoHostedUISignIn}
            onForgotPassword={handleBallotForgotPassword}
            onRegister={handleBallotRegister}></BallotSignInForm>
    },
    [ssoFormTypes.BallotSignInSuccessForm]: ({
        formData,
        ssoDomain }) => {
        return <BallotSignInSuccessForm
            formData={formData}
            ssoDomain={ssoDomain}></BallotSignInSuccessForm>
    },
    [ssoFormTypes.PreRegisterForm]: ({
        formData,
        ssoDomain,
        handleSignIn,
        handleForgotPassword,
        handleBallotRegister }) => {
        return <BallotSignInForm
            formData={formData}
            ssoDomain={ssoDomain}
            onSignIn={handleSignIn}
            onForgotPassword={handleForgotPassword}
            onRegister={handleBallotRegister}></BallotSignInForm>
    },
};
